/**
 * 👷 Mitarbeiter-Modus (Sonderfunktion „staffMode", z. B. Green Goat)
 *
 * Pro GERÄT: vereinfachte Oberfläche (nur „Neues Paket", Suche, Liste), Beenden nur per PIN.
 * Aktiv nur, wenn das KONTO die Sonderfunktion hat UND auf dem Gerät eingeschaltet — wird die
 * Freischaltung entfernt, ist der Modus automatisch aus (nie ein „gefangenes" Gerät).
 * PIN wird nur als SHA-256-Hash gespeichert.
 */
import { hasCustomFeature } from './customFeatures';

const KEY = 'kiosk_staff_mode';
const SALT = 'paketpilot-staff:';

function read() {
  try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch { return null; }
}

function notify(on) {
  try { window.dispatchEvent(new CustomEvent('kiosk:staff-mode', { detail: on })); } catch { /* */ }
}

export async function hashPin(pin) {
  const text = SALT + String(pin || '');
  try {
    const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(text));
    return Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, '0')).join('');
  } catch {
    // Fallback ohne WebCrypto (sollte unter HTTPS nie nötig sein)
    let h = 0;
    for (let i = 0; i < text.length; i++) h = (h * 31 + text.charCodeAt(i)) | 0;
    return 'x' + (h >>> 0).toString(16);
  }
}

export function isValidPin(pin) {
  return /^\d{4}$/.test(String(pin || ''));
}

export function isStaffMode() {
  const s = read();
  return !!(s && s.on && s.pin && hasCustomFeature('staffMode'));
}

export async function enableStaffMode(pin) {
  if (!isValidPin(pin)) return false;
  try { localStorage.setItem(KEY, JSON.stringify({ on: true, pin: await hashPin(pin) })); } catch { return false; }
  notify(true);
  return true;
}

export async function checkPin(pin) {
  const s = read();
  return !!(s && s.pin && (await hashPin(pin)) === s.pin);
}

export function disableStaffMode() {
  try { localStorage.removeItem(KEY); } catch { /* */ }
  notify(false);
}
